// src/config.js

const config = {
  // Site Information
  siteTitle: 'SeriousRun',
  siteTagline: "Dedication and Sacrifice.",
  siteName: 'SeriousRun',
  siteLegal: 'SeriousRun, LLC',
  footerTagline: "SeriousRun connects senior communities with exceptional experiences.",

  //Front end base
  siteBaseURL: 'https://app.seriousrun.co',

  // Contact
  supportEmail: 'hello@seriousrun.co',
  siteTermsURL: 'https://www.seriousrun.co/terms',
  siteTermsVersion: '2026-01-05',
  sitePrivacyURL: 'https://www.seriousrun.co/privacy',
  sitePrivacyVersion: '2026-01-08',
  siteFAQURL: 'https://www.seriousrun.co/faq',
  siteAccessibilityURL: 'https://www.seriousrun.co/accessibility',
  siteCodeofConductURL: 'https://www.seriousrun.co/conduct',
};

export default config;